import Fetch from "../../utils/Fetch";

let userDataRequest = null;

export default {
    namespaced: true,
    state: {
        userData: null,
    },
    mutations: {
        setUserData(state, data) {
            state.userData = data;
            let phone = data?.phone?.replace(/[^\d]/g, '');
            if (phone) {
                window.ymSetUserID?.(phone);
            }
        },
    },
    actions: {
        async requestUserData({commit, state, dispatch}) {
            if (state.userData) return {success: true, data: state.userData}
            if (userDataRequest) return userDataRequest
            userDataRequest = (async () => {
                try {
                    const response = await Fetch('user/data/', {method: 'GET'});
                    if (response.success) {
                        commit('setUserData', response.data)
                        // Запрашиваем уведомления после успешного получения данных пользователя
                        await dispatch('notifications/requestNotifications', null, { root: true })
                    } else {
                        commit('setUserData', null)
                    }
                    return {...response}
                } catch (error) {
                    commit('setUserData', null)
                    return {success: false, data: null, message: error?.message || 'Не удалось загрузить профиль'}
                }
            })();
            try {
                return await userDataRequest
            } finally {
                userDataRequest = null
            }
        },
    },
    getters: {
        getUserData: state => state.userData,
        isTester: state => state.userData?.is_tester === true,
    }
}
